import i18n from 'modules/core/lib/i18n'

export const getCustomFieldLabel = (fieldType: string) => {
  switch (fieldType) {
    case 'number': // TODO: Review this because is not a backend valid value
      return i18n.t('settings.custom_fields.new.labels.number')
    case 'text':
      return i18n.t('settings.custom_fields.new.labels.text')
    case 'long_text':
      return i18n.t('settings.custom_fields.new.labels.long_text')
    case 'date':
      return i18n.t('settings.custom_fields.new.labels.date')
    case 'rating':
      return i18n.t('settings.custom_fields.new.labels.rating')
    case 'checkbox':
      return i18n.t('settings.custom_fields.new.labels.checkbox')
    case 'single_choice':
      return i18n.t('settings.custom_fields.new.labels.single_choice')
    case 'multiple_choice':
      return i18n.t('settings.custom_fields.new.labels.multiple_choice')
    case 'cents':
      return i18n.t('settings.custom_fields.new.labels.cents')
    case 'money': // TODO: Review this because is not backend valid value but there is no translation for this
      return i18n.t('settings.custom_fields.new.labels.money')
    default:
      throw new Error(`Invalid field type: ${fieldType}`)
  }
}
